require('./rooms-accordion.style.less');
require('./rooms-accordion-directive-template.html');

angular.module('bbl.dashboard.directive.rooms-accordion', [])
    .directive('roomsAccordion', [function() {
        return {
            restrict: 'E',
            templateUrl: 'rooms-accordion-directive-template.html',
            scope: {
                bridge: '=',
                user: '=',
                callers: '=',
            },

            controller: ['$scope', 'Api', '$window', '$timeout', roomsAccordionCtrl],
            link: function($scope, $el, atts) {},
        };
    }]);

function roomsAccordionCtrl($scope, Api, $window, $timeout) {
    var bridges = {};
    window.__bridges = bridges;
    var bridge = function(id) {
        id = id || $scope.bridge.id;
        return bridges[id] || (bridges[id] = {rooms: {}, callers: {}});
    };

    var callersByRoom = {};

    var getBridgeRooms = function() {
        var rooms = (($scope.bridge||{}).rooms||[]);
        rooms = rooms.reduce(function(rooms, room) {
            return rooms[room.id] = room, rooms;
        }, {});

        return angular.extend(bridge().rooms, rooms);
    };

    var getCallerRoom = function(caller) {
        var rooms = (($scope.bridge||{}).rooms||[]);
        return rooms.find(function(room) {
            return room.id === caller.room;
        });
    };

    $scope.getCallers = function(room) {
        var roomName = room || 'main';

        if(!callersByRoom[roomName]) {
            callersByRoom[roomName] = [];
        }

        if(!$scope.bridge) {
            return callersByRoom[roomName];
        }

        var roomCallers = $scope.callers.filter(function(caller) {
            var room = bridge().rooms[roomName] || {},
                callerRoom = getCallerRoom(caller) || {};

            return (roomName === 'main' && (!caller.room || callerRoom.status === 'C')) ||
                caller.room === room.id && callerRoom.status === 'O';
        });

        var prev = callersByRoom[roomName].map(function(d) { return d.id }).sort().join('||');
        var next = roomCallers.map(function(d) { return d.id }).sort().join('||');

        if (prev === next) {
          return callersByRoom[roomName];
        }

        callersByRoom[roomName] = roomCallers;
        return callersByRoom[roomName];
    };

    // force view update when callers object changes
    $scope.$watch(function(){return $scope.callers;}, function() {
        $timeout(function() {
          $scope.getCallers();
          Object.keys($scope.getBridgeRooms()).forEach(function(roomId) { $scope.getCallers(roomId); });
        });
    });

    $scope.getBridgeRooms = getBridgeRooms;

    $scope.count = function(obj) {
        return Object.keys(obj||{}).length;
    };

    $scope.mergeRoom = function($event, room) {
        $event.stopPropagation();
        if(!$window.confirm('Are you sure you want to merge this room into main?')) {
            return;
        }

        var closeRoom = function() {
            bridge().rooms[room.name].status = 'C';
        };

        Api.bridges.mergeRoom(room.id).then(closeRoom, closeRoom);
    };

    $scope.hangup = function($event, room) {
        $event.stopPropagation();
        Api.bridges.hangupRoom($scope.bridge.id, (room||{}).id).then(function() {
            // debugger
        });
    };

    $scope.muteall = function($event, room) {
        $event.stopPropagation();
        Api.bridges.muteRoom(room.id).then(function() {
        });
    };

    $scope.reconstitute = function($event) {
        var reconstituteRooms = function() {
            Object.keys(bridge().rooms).forEach(function(roomName) {
                bridge().rooms[roomName].status = 'O';
            });
        };
        Api.bridges.reconstituteRooms($scope.bridge.id).then(reconstituteRooms, reconstituteRooms);
    };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/rooms-accordion/rooms-accordion.directive.js
 ** module id = 328
 ** module chunks = 0
 **/